export const US_STATES = [
  'AL','AK','AZ','AR','CA','CO','CT','DE','FL','GA',
  'HI','ID','IL','IN','IA','KS','KY','LA','ME','MD',
  'MA','MI','MN','MS','MO','MT','NE','NV','NH','NJ',
  'NM','NY','NC','ND','OH','OK','OR','PA','RI','SC',
  'SD','TN','TX','UT','VT','VA','WA','WV','WI','WY','DC',
];

export const VERTICALS = [
  'plumbing','hvac','roofing','electrical','landscaping','cleaning',
];

export const RESPONSE_TIMES = [
  'Same day','24 hours','48 hours','1 week',
];

export const POST_CATEGORIES = [
  'Tips & Advice','Maintenance','Emergency','Seasonal','How-To','News',
];

/** Convert a name/title to a URL-safe slug */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

/** Shared PlusIcon for add buttons */
export const PlusIconPath = 'M12 4.5v15m7.5-7.5h-15';
